import type { AxiosResponse } from 'axios';
import axios from 'axios';

export const update = (
  enabled: boolean,
  siteId: number,
): Promise<AxiosResponse<{ success: boolean }>> =>
  axios.post(`/api/v1/sites/${siteId}/integrations/unbounce`, {
    action: 'tag_recordings',
    tag_recordings: enabled,
  });
